<template>
  <v-footer class="px-0 mt-10" color="transparent" style="display: flex; align-items: end;">
    <v-row >
      <div >
        <div class="primary--text">© 2022 <a href="https://flatlogic.com/" class="text-decoration-none">Ezequiel Flores</a>, All rights reserved.</div>
      </div>
      <!-- <div>
        <v-btn
                v-for="icon in icons"
                :key="icon.icon"
                :href="icon.link"
                class="mr-1"
               
                icon
        >
          <v-icon size="24px">{{ icon.icon }}</v-icon>
        </v-btn>
      </div> -->
    </v-row>
  </v-footer>
</template>

<script>


export default {
  name: 'Footer',

  data: () => ({
    // config,
    // icons: [
    //   {icon: 'mdi-facebook', link: 'https://twitter.com/flatlogic/'},
    //   {icon: 'mdi-twitter', link: 'https://www.facebook.com/flatlogic'},
    //   {icon: 'mdi-github', link: 'https://github.com/flatlogic/'},

    // ],
    // links: [
    //   {text: 'Flatlogic', link: 'https://flatlogic.com/'},
    //   {text: 'About Us', link: 'https://flatlogic.com/about'},
    //   {text: 'Blog', link: 'https://flatlogic.com/blog'},
    // ]
  }),
}
</script>
<style src="./Footer.scss" lang="scss"/>


